<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <div class="row">
                <div class="col-12 mb-1">
                    <label class="form-label">Kod</label>
                    <v-validator :errors="errors" parameter="Code" :watch="form.Code">
                        <input type="text" class="form-control" placeholder="Kod" v-model="form.Code" />
                    </v-validator>
                </div>

                <div class="col-12 mb-1">
                    <label class="form-label">Ad</label>
                    <v-validator :errors="errors" parameter="Name" :watch="form.Name">
                        <input type="text" class="form-control" placeholder="Ad" v-model="form.Name" />
                    </v-validator>
                </div>

                <div class="col-12 mb-1">
                    <label class="form-label">Şube</label>
                    <v-validator :errors="errors" parameter="FuelStorageOwningBranchId" :watch="form.FuelStorageOwningBranchId">
                        <v-select-list v-model="branch" :options="branches" label="Name" placeholder="Şube Seçiniz" />
                    </v-validator>
                </div>
            </div>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table ref="table" :add-callback="createNew" :fields="fields" name="integrated-storage-class" :buttons="buttons" pagination="client" search :items-provider="provider"> </v-table>
    </b-card>
</template>

<script>
import api from "@/api/fuel-storage";
import { BCard } from "bootstrap-vue";
import CompanyApi from "@/api/company";
import VValidator from "@/components/VValidator.vue";

export default {
    name: "IntegratedStorageClassView",
    components: { BCard, VValidator },
    data() {
        return {
            errors: {},
            editing: false,
            loading: false,
            branches: [],
            form: {
                Id: null,
                Code: "",
                Name: "",
                FuelStorageOwningBranchId: null,
            },
            fields: [
                { name: "Kod", key: "Code", sortable: true, thClass: "w-30 text-nowrap", tdClass: "text-nowrap" },
                { name: "Ad", key: "Name", sortable: true, thClass: "w-30 text-nowrap", tdClass: "text-nowrap" },
                { name: "Şube", key: "FuelStorageOwningBranchName", sortable: true, thClass: "w-40 text-nowrap" },
            ],
            buttons: [
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.delete },
            ],
        };
    },

    mounted() {
        this.loadBranches();
    },

    computed: {
        branch: {
            get() {
                return this.branches.find((b) => b.Id === this.form.FuelStorageOwningBranchId) || null;
            },
            set(val) {
                this.form.FuelStorageOwningBranchId = val?.Id || null;
            },
        },
    },

    methods: {
        clearForm() {
            this.editing = false;
            this.form.Id = null;
            this.form.Code = "";
            this.form.Name = "";
            this.form.FuelStorageOwningBranchId = null;
        },
        createNew() {
            this.clearForm();
            this.$showModal("create-or-update");
        },
        edit(item) {
            this.editing = true;
            this.form = {
                Id: item.Id,
                Code: item.Code,
                Name: item.Name,
                FuelStorageOwningBranchId: item.FuelStorageOwningBranchId,
            };
            this.$showModal("create-or-update");
        },
        provider(data) {
            return api.IntegratedStorageClass.List(data);
        },
        createOrUpdate() {
            this.errors = {};
            if (!this.form.Code) this.errors.Code = "Kod zorunludur";
            if (!this.form.Name) this.errors.Name = "Ad zorunludur";
            if (!this.form.FuelStorageOwningBranchId) this.errors.FuelStorageOwningBranchId = "Şube zorunludur";

            if (Object.keys(this.errors).length > 0) return;

            this.loading = true;
            api.IntegratedStorageClass.CreateOrUpdate(this.editing, this.form)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.clearForm();
                        this.$hideModal("create-or-update");
                    }
                    this.$result(res);
                    this.loading = false;
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false;
                });
        },
        delete(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem ${item.Name} entegre depo sınıfını silecektir ve geri alınamaz.`).then((result) => {
                if (result) {
                    api.IntegratedStorageClass.Delete(item.Id)
                        .then((res) => {
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                            this.$result(res);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
        async loadBranches() {
            try {
                const res = await CompanyApi.Branch.ListByCode("O");
                if (res.data.Success) this.branches = res.data.Data || [];
            } catch (err) {
                console.error("Error loading branches:", err);
            }
        },
    },
};
</script>

<style scoped></style>
